import _ from 'lodash';
import React from 'react';

import { format } from 'src/lib/format';

import { HistogramStackConfig } from '../helpers/useQueryHistogramStackInfo';

import { StackCount } from './Histogram';

export type HistogramStackConfigWithoutData = Omit<
  HistogramStackConfig<unknown>,
  'data' | 'hasData' | 'getValue'
> & {
  data?: never;
  hasData?: never;
  getValue?: never;
};
export type HistogramTooltipProps = {
  title?: string;
  stackCounts?: StackCount[];
  activeSeries?: boolean[];
  stacks?: HistogramStackConfigWithoutData[];
  rangeBeginMs?: number;
  rangeEndMs?: number;
  percentile?: number;
};

export const HistogramTooltip = ({
  stackCounts = [],
  activeSeries,
  stacks = [],
  rangeBeginMs,
  rangeEndMs,
  percentile = 0,
}: HistogramTooltipProps) => {
  return (
    <>
      {stackCounts.map((value, stackId) => {
        if (activeSeries && !activeSeries[stackId]) return null;
        const { label, unit } = stacks[stackId] ?? {};
        return (
          <strong key={`${value.label}${label}${unit}`} className="block">
            {label ? `${label}: ` : ''}
            {value.label}
            {unit}
          </strong>
        );
      })}
      <div className="text-xs">
        Range: {format.ms(rangeBeginMs, 1, false)} -{' '}
        {format.ms(rangeEndMs, 1, false)}
        <br />
        Percentile: {Number(percentile.toPrecision(2))}% |{' '}
        {Number((100 - percentile).toPrecision(2))}%
      </div>
    </>
  );
};
